module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"readmoreQuestion":"Klar for mer hjerneprat?","readmoreButton":"Klikk for å lese mer"},"en":{"readmoreQuestion":"Interested in brain science?","readmoreButton":"Click to read more"}}')
  delete Component.options._Ctor
}
